import { useContext, useEffect, useState } from 'react'
import './index.less'
import { Button } from 'antd'
import { CheckOutlined, MinusOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons'
import { batch } from 'react-redux'
import SegmentContext from '@/components/SegmentHelpers/hooks/createContext'
import {
  CLICKTYPE_ADD,
  CLICKTYPE_BOX,
  CLICKTYPE_NONE,
  CLICKTYPE_REMOVE,
  SEGTYPE_BOX,
  SEGTYPE_CLICK,
  SEGTYPE_EVERYTHING,
  SEGTYPE_HOVER
} from '@/components/SegmentHelpers/config'
import {
  base64ToImageElement,
  everythingImageDataToImage,
  everythingImageDataToSticker,
  imageDataToImage,
  imageToImageData
} from '@/components/SegmentHelpers/maskUtils'
import { getEverything, getResult, SEGMENTINFO_URL } from '@/server'
import { useAppSelector } from '@/hooks'

const PanelArea = () => {
  const {
    image: [image],
    currentImage: [_currentImage],
    currentImageData: [_currentImageData],
    clickType: [clickType, setClickType],
    segmentType: [_segmentType, setSegmentType],
    clicks: [, _setClicks],
    isReset: [, setIsReset],
    clipData: [clipData, _setClipData],
    stickers: [stickers, setStickers],
    maskImg: [_maskImg, setMaskImg],
    resultMask: [resultMask, setResultMask],
    resultHighlightMask: [, _setResultHighlightMask],
    everythingMask: [everythingMask, setEverythingMask],
    overCircle: [overCircle],
    isEverythingRemoved: [isEverythingRemoved, setIsEverythingRemoved],
    isLoading: [isLoading, setIsLoading],
    isChanging: [, setIsChanging]
  } = useContext(SegmentContext)!
  const imageId = useAppSelector((state) => state.analysisImageInfo.imageId)
  const userId = useAppSelector((state) => state.login.userId)
  const [selected, setSelected] = useState<number>(1)
  const handleAddClick = () => {
    setClickType(CLICKTYPE_ADD)
    setSegmentType(SEGTYPE_CLICK)
  }
  const handleRemoveClick = () => {
    batch(() => {
      setClickType(CLICKTYPE_REMOVE)
      setSegmentType(SEGTYPE_CLICK)
    })
  }
  const handleClickReset = () => {
    setClickType(CLICKTYPE_ADD)
    setSegmentType(SEGTYPE_HOVER)
    setIsReset(true)
    setIsEverythingRemoved(false)
  }
  const handleBoxReset = () => {
    setClickType(CLICKTYPE_BOX)
    setSegmentType(SEGTYPE_BOX)
    setIsReset(true)
    setIsEverythingRemoved(false)
  }
  const handleEverythingRemoveReset = () => {
    setEverythingMask(
      everythingMask.map((mask) => {
        return { ...mask, display: true }
      })
    )
  }
  const handleCutOut = () => {
    if (clipData) setStickers([clipData, ...stickers])
    if (selected == 1) {
      handleClickReset()
    } else if (selected == 2) {
      handleBoxReset()
    } else if (selected == 3 && image) {
      const clips = everythingImageDataToSticker(
        everythingMask,
        imageToImageData(image),
        resultMask
      )
      setStickers([...clips, ...stickers])
      setSegmentType(SEGTYPE_EVERYTHING)
    }
    setIsChanging(true)
  }
  const handleSelect = (index: number) => {
    setSelected(index)
  }
  const handleEverythingRemove = () => {
    setIsEverythingRemoved(true)
  }
  const handleEverythingRemoveFinish = () => {
    setIsEverythingRemoved(false)
  }
  const drawEverythingMask = () => {
    if (image) {
      setMaskImg(everythingImageDataToImage(everythingMask, image.width, image.height, overCircle))
    }
  }
  const loadEverything = async (filename: string) => {
    // setIsLoading(true)
    getEverything({ name: filename })
      .then((response: any) => {
        // console.log(response)
        const masks = response['data']['content'].map((mask: any, id: number) => ({
          ...mask,
          id: id,
          display: true,
          point_coords: mask.point_coords.map((point: any) => {
            return {
              x: point[0],
              y: point[1],
              width: 0,
              height: 0,
              clickType: 1
            }
          }),
          color: [
            Math.floor(Math.random() * 255) + 1,
            Math.floor(Math.random() * 255) + 1,
            Math.floor(Math.random() * 255) + 1,
            255
          ]
        }))
        setEverythingMask(masks)
      })
      .catch((error) => {
        console.log(error)
      })
  }
  const loadStickers = async (filename: string) => {
    getResult({ name: filename })
      .then(async (response: any) => {
        // console.log(response)
        const data = response.data.content
        if (data.length == 0) return
        const pic_que: any = []
        const stickers = data.map((sticker: any) => {
          // const url = new URL(sticker.img, SEGMENTINFO_URL).toString()
          const url = SEGMENTINFO_URL + '/' + sticker.img
          // console.log(url)
          pic_que.push(
            base64ToImageElement(url)
              .then((image) => {
                sticker.img = image
              })
              .catch((error) => {
                console.log(error)
              })
          )
          return sticker
        })
        //确保图片全部加载
        await Promise.all(pic_que)
        console.log('set stick')

        setStickers([...stickers])
      })
      .catch((error) => {
        console.log(error)
      })
  }
  useEffect(() => {
    if (selected == 1) {
      handleClickReset()
    } else if (selected == 2) {
      handleBoxReset()
    } else if (selected == 3) {
      setClickType(CLICKTYPE_NONE)
      setSegmentType(SEGTYPE_EVERYTHING)
      setIsReset(true)
      handleEverythingRemoveReset()
      drawEverythingMask()
    }
  }, [selected])
  useEffect(() => {
    if (selected == 3 && !isLoading) {
      // console.log('draw')
      drawEverythingMask()
    }
  }, [everythingMask, overCircle])
  useEffect(() => {
    setStickers([])
    console.log('init')
    setSelected(1)
    if (imageId != '' && image) {
      console.log('loading...')
      loadStickers(`${imageId}_${userId}.png`)
      loadEverything(imageId + '.png')
      const arr = new Uint8ClampedArray(4 * image.width * image.height).fill(0)
      setResultMask(imageDataToImage(new ImageData(arr, image.width, image.height)))
    }
    setIsLoading(false)
  }, [image])

  return (
    <div className='tool-row'>
      <div
        className={'tool-item ' + (selected === 1 ? 'item-selected' : '')}
        onClick={() => handleSelect(1)}
      >
        <h4>悬停&点击</h4>
        <p>点击图像进行选取。</p>
        <div className='tool-button-area'>
          <div className='tool-button'>
            <Button
              size='middle'
              icon={<PlusOutlined />}
              type={selected == 1 && clickType == CLICKTYPE_ADD && image ? 'primary' : 'default'}
              onClick={handleAddClick}
              disabled={selected == 1 && image ? false : true}
            />
            <p>添加</p>
          </div>
          <div className='tool-button'>
            <Button
              size='middle'
              icon={<ReloadOutlined />}
              onClick={handleClickReset}
              disabled={selected == 1 && clipData ? false : true}
            />
            <p>重置</p>
          </div>
          <div className='tool-button'>
            <Button
              size='middle'
              icon={<MinusOutlined />}
              onClick={handleRemoveClick}
              type={selected == 1 && clickType == CLICKTYPE_REMOVE ? 'primary' : 'default'}
              disabled={selected == 1 && clipData ? false : true}
            />
            <p>消除</p>
          </div>
        </div>
        <Button onClick={handleCutOut} disabled={selected == 1 && clipData ? false : true}>
          标出对象
        </Button>
      </div>
      <div
        className={'tool-item ' + (selected === 2 ? 'item-selected' : '')}
        onClick={() => handleSelect(2)}
      >
        <h4>框选</h4>
        <p>框选图像进行选取。</p>
        <div className='tool-button-area'>
          <div className='tool-button'>
            <Button
              size='middle'
              icon={<PlusOutlined />}
              onClick={handleAddClick}
              type={
                selected == 2 && (clickType == CLICKTYPE_ADD || clickType == CLICKTYPE_BOX)
                  ? 'primary'
                  : 'default'
              }
              disabled={selected == 2 && image ? false : true}
            />
            <p>添加</p>
          </div>
          <div className='tool-button'>
            <Button
              size='middle'
              icon={<ReloadOutlined />}
              onClick={handleBoxReset}
              disabled={selected == 2 && clipData ? false : true}
            />
            <p>重置</p>
          </div>
          <div className='tool-button'>
            <Button
              size='middle'
              icon={<MinusOutlined />}
              onClick={handleRemoveClick}
              type={selected == 2 && clickType == CLICKTYPE_REMOVE ? 'primary' : 'default'}
              disabled={selected == 2 && clipData ? false : true}
            />
            <p>消除</p>
          </div>
        </div>
        <Button onClick={handleCutOut} disabled={selected == 2 && clipData ? false : true}>
          标出对象
        </Button>
      </div>
      <div
        className={
          'tool-item ' + (selected === 3 && everythingMask.length > 0 ? 'item-selected' : '')
        }
        onClick={() => handleSelect(3)}
      >
        <h4>自动标识</h4>
        {everythingMask.length === 0 ? (
          <p>数据加载中..</p>
        ) : (
          <>
            <p>{isEverythingRemoved ? '点击红点来消除标注。' : '自动选取图片中所有物体。'}</p>
            {isEverythingRemoved ? (
              <div className='tool-button-area'>
                <div className='tool-button'>
                  <Button
                    size='middle'
                    icon={<CheckOutlined />}
                    onClick={handleEverythingRemoveFinish}
                  />
                  <p className='m-1 text-xs'>完成</p>
                </div>
                <div className='tool-button'>
                  <Button
                    size='middle'
                    icon={<ReloadOutlined />}
                    onClick={handleEverythingRemoveReset}
                  />
                  <p className='m-1 text-xs'>重置</p>
                </div>
              </div>
            ) : (
              <div className='tool-button-area'>
                <div className='tool-button'>
                  <Button
                    size='middle'
                    icon={<MinusOutlined />}
                    onClick={handleEverythingRemove}
                    disabled={selected == 3 ? false : true}
                  />
                  <p className='m-1 text-xs'>消除</p>
                </div>
              </div>
            )}
            <Button
              onClick={handleCutOut}
              disabled={selected == 3 && everythingMask ? false : true}
            >
              标出所有对象
            </Button>
          </>
        )}
      </div>
    </div>
  )
}
export default PanelArea
